import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=107f59a1&scoped=true"
import script from "./Roulette.vue?vue&type=script&lang=js"
export * from "./Roulette.vue?vue&type=script&lang=js"
import style0 from "./Roulette.vue?vue&type=style&index=0&id=107f59a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f59a1",
  null
  
)

export default component.exports